export { EditorPage } from "features/editor/pages/EditorPage";
export const EDITOR_PAGE_SIZE_KEY = "editor-page-size";
